import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import './LoaderCard.scss';

const LoaderCard = ({ t, text, className }) => {
  const containerClass = classnames('loader_card', className);

  return (
    <div data-test="loader-container" className={containerClass}>
      <div data-test="loader-text" className="loader_card__text">
        {text || t('dashboard.loading_info')}
      </div>
      <FontAwesomeIcon spin icon={['fal', 'spinner-third']} className="_ml-2" />
    </div>
  );
};

LoaderCard.propTypes = {
  className: PropTypes.string,
  text: PropTypes.node
};

export default translate()(LoaderCard);
